<template lang="pug">
  div.total
    div.tit 計{{ qua }}点
    div.price {{ price }}
    div.yen 円
</template>

<script>
export default {
  name: 'Total',
  components: {
  },
  data () {
    return {
      timer: {},
      qua: 0,
      price: 0,
      set: {},
      space: [],
      width: 0,
      height: 0,
      depth: 0
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      let me = this;
      if (me.sets[me.number] !== undefined) {
        me.set = me.sets[me.number];
        me.space = me.set.space;
        me.width = me.set.space[0];
        me.height = me.set.space[1];
        me.depth = me.set.space[2];
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.computeTotal();
        }, 500);
      }
    },
    computeTotal () {
      // 商品合計計算
      this.qua = 0;
      let price = 0;
      for (let prop in this.set.slits) {
        if (this.set.slits[prop].slit !== undefined) {
          price += Number(this.set.slits[prop].slit.price);
          this.qua++;
        }
        for (let prop2 in this.set.slits[prop].item) {
          price += Number(this.set.slits[prop].item[prop2].price);
          this.qua++;
        }
        for (let prop2 in this.set.slits[prop].floor) {
          price += Number(this.set.slits[prop].floor[prop2].price);
          this.qua++;
        }
      }
      for (let prop in this.set.rails) {
        if (this.set.rails[prop] !== undefined) {
          price += Number(this.set.rails[prop].price);
          this.qua++;
        }
      }
      this.price = this.addComma(price);
    }
  },
  created () {
    if (this.sets[this.number] !== undefined) {
      this.set = this.sets[this.number];
      this.space = this.sets[this.number].space;
    }
  },
  mounted () {
  }
};
</script>

<style lang="stylus">
  .total
    display flex
    align-items center
    font-size 10px
    border 1px solid #dddddd
    padding 9px 15px
    border-radius 5px
    font-weight bold
    user-select none
    .price
      width 70px
      color #FF4E00
      text-align right
    .btn
      background-color #2E7C80
      color #ffffff
      font-weight bold
      border none
      border-radius 5px
      padding 10px 15px
      margin-left 10px
      cursor pointer
      img
        display inline-block
        vertical-align middle
        margin-top -2px
        margin-right 5px
</style>



// WEBPACK FOOTER //
// src/components/header/Total.vue